module.exports = __webpack_public_path__ + "img/c03_buildingtemper_Normal_ua.58a6f890.webp";